// test2394
(2394 && 0);
